import React, { useState, useEffect, useCallback } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { Thumb } from "./CarouselThumb";
import { PrevButton, NextButton, DotButton } from "./CarouselButtons";
import Image from "next/image";
import * as cx from "classnames/bind";
import e from "styles/Carousel.module.scss";

const ProductCarousel = ({ slides, noThumbs, dots }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [mainViewportRef, embla] = useEmblaCarousel({ skipSnaps: false });
  const [thumbViewportRef, emblaThumbs] = useEmblaCarousel({
    containScroll: "keepSnaps",
    selectedClass: "",
    dragFree: true,
  });

  const [prevBtnEnabled, setPrevBtnEnabled] = useState(false);
  const [nextBtnEnabled, setNextBtnEnabled] = useState(false);

  const onThumbClick = useCallback(
    (index) => {
      if (!embla || !emblaThumbs) return;
      if (emblaThumbs.clickAllowed()) embla.scrollTo(index);
    },
    [embla, emblaThumbs],
  );

  const onSelect = useCallback(() => {
    if (!embla || !emblaThumbs) return;
    setSelectedIndex(embla.selectedScrollSnap());
    emblaThumbs.scrollTo(embla.selectedScrollSnap());
    setPrevBtnEnabled(embla.canScrollPrev());
    setNextBtnEnabled(embla.canScrollNext());
  }, [embla, emblaThumbs, setSelectedIndex]);

  useEffect(() => {
    if (!embla) return;
    onSelect();
    embla.on("select", onSelect);
  }, [embla, onSelect]);

  const scrollPrev = useCallback(() => embla && embla.scrollPrev(), [embla]);
  const scrollNext = useCallback(() => embla && embla.scrollNext(), [embla]);
  const scrollTo = useCallback(
    (index) => embla && embla.scrollTo(index),
    [embla],
  );

  const mediaByIndex = [
    {
      src: "/img/slides/qkit/qkit1.jpeg",
      label: "Q-kit - Bar set - Cocktail Kit",
    },
    {
      src: "/img/slides/qkit/qkit2.jpeg",
      label: "Q-kit - Bar set - Cocktail Kit",
    },
    {
      src: "/img/slides/qkit/qkit3.jpeg",
      label: "Q-kit - Bar set - Cocktail Kit",
    },
    {
      src: "/img/slides/qkit/qkit4.jpeg",
      label: "Q-kit - Bar set - Cocktail Kit",
    },
    {
      src: "/img/slides/qkit/qkit5.jpeg",
      label: "Q-kit - Bar set - Cocktail Kit",
    },
    {
      src: "/img/slides/qkit/qkit6.jpeg",
      label: "Q-kit - Bar set - Cocktail Kit",
    },
    {
      src: "/img/slides/qkit/qkit7.jpeg",
      label: "Q-kit - Bar set - Cocktail Kit",
    },
    {
      src: "/img/slides/qkit/qkit8.jpeg",
      label: "Q-kit - Bar set - Cocktail Kit",
    },
    {
      src: "/img/slides/qkit/qkit9.jpeg",
      label: "Q-kit - Bar set - Cocktail Kit",
    },
    {
      src: "/img/slides/qkit/qkit10.jpeg",
      label: "Q-kit - Bar set - Cocktail Kit",
    },
    {
      src: "/img/slides/qkit/qkit11.jpeg",
      label: "Q-kit - Bar set - Cocktail Kit",
    },
    {
      src: "/img/slides/qkit/qkit12.jpeg",
      label: "Q-kit - Bar set - Cocktail Kit",
    },
    {
      src: "/img/slides/qkit/qkit13.jpeg",
      label: "Q-kit - Bar set - Cocktail Kit",
    },
    {
      src: "/img/slides/qkit/qkit14.jpeg",
      label: "Q-kit - Bar set - Cocktail Kit",
    },
    {
      src: "/img/slides/qkit/qkit15.jpeg",
      label: "Q-kit - Bar set - Cocktail Kit",
    },
  ];

  return (
    <div className={cx(e.emblaHolder)}>
      <div className={cx(e.embla)}>
        <div className={cx(e.embla__viewport)} ref={mainViewportRef}>
          <div className={cx(e.embla__container)}>
            {mediaByIndex.map((media, index) => (
              <div
                className={cx(e.embla__slide, e.embla__slide__qkit)}
                key={index}
              >
                <div className={cx(e.embla__slide__inner)}>
                  <Image
                    className={cx(e.embla__slide__img)}
                    src={media.src}
                    alt={media.label}
                    layout="responsive"
                    objectFit="cover"
                    width={800}
                    height={800}
                    placeholder="blur"
                    blurDataURL={media.src}
                  />
                </div>
              </div>
            ))}
          </div>
          {dots && (
            <div className={cx(e.embla__dots)}>
              {mediaByIndex.map((media, index) => (
                <DotButton
                  onClick={() => onThumbClick(index)}
                  selected={index === selectedIndex}
                  imgSrc={media.src}
                  key={index}
                />
              ))}
            </div>
          )}
          <PrevButton onClick={scrollPrev} enabled={prevBtnEnabled} />
          <NextButton onClick={scrollNext} enabled={nextBtnEnabled} />
        </div>
      </div>
      <div className={cx(e.embla, e.embla__thumb, noThumbs ? "hidden" : "")}>
        <div className={cx(e.embla__viewport)} ref={thumbViewportRef}>
          <div className={cx(e.embla__container, e.embla__container__thumb)}>
            {mediaByIndex.map((media, index) => (
              <Thumb
                onClick={() => onThumbClick(index)}
                selected={index === selectedIndex}
                imgSrc={media.src}
                key={index}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCarousel;
